import { DISCLAIMERS_FETCH_FAILED, DISCLAIMERS_FETCH_SUCCEEDED } from '../constants'

export const disclaimersFetchSucceeded = disclaimers => ({
  type: DISCLAIMERS_FETCH_SUCCEEDED,
  disclaimers,
})
export const disclaimersFetchFailed = error => ({
  type: DISCLAIMERS_FETCH_FAILED,
  error,
})
